import React, { useEffect } from "react";

import { TextField } from "@formant/ui/component/common/v2/TextField";

import { TextareaField } from "../../common/TextareaField";

interface IOrganizationPromptComponents {
    industryType: string;
    keyOperationalGoals: string;
    coreValues: string;
    organizationalHealthKPIs: string;
    additionalDescription?: string;
}

export function OrganizationPromptBuilder(props: {
    text: string | undefined;
    onTextChange: (text: string) => void;
}) {
    const [organizationPromptComponents, setOrganizationPromptComponents] =
        React.useState<IOrganizationPromptComponents | undefined>();

    useEffect(() => {
        // on start, try to parse out the organization prompt components from the text
        if (props.text) {
            try {
                const parsedOrganizationPromptComponents = JSON.parse(
                    props.text,
                ) as IOrganizationPromptComponents;
                setOrganizationPromptComponents(
                    parsedOrganizationPromptComponents,
                );
            } catch (error) {
                setOrganizationPromptComponents({
                    industryType: "",
                    keyOperationalGoals: "",
                    coreValues: "",
                    organizationalHealthKPIs: "",
                    additionalDescription: props.text,
                });
            }
        } else {
            setOrganizationPromptComponents({
                industryType: "",
                keyOperationalGoals: "",
                coreValues: "",
                organizationalHealthKPIs: "",
            });
        }
    }, []);

    useEffect(() => {
        if (organizationPromptComponents) {
            props.onTextChange(
                JSON.stringify(organizationPromptComponents, null, 2),
            );
        }
    }, [organizationPromptComponents]);

    if (organizationPromptComponents) {
        return (
            <div>
                <TextField
                    label="Industry type"
                    placeholder="e.g. Agriculture, Logistics, Manufacturing"
                    value={organizationPromptComponents.industryType}
                    onChange={change =>
                        setOrganizationPromptComponents({
                            ...organizationPromptComponents,
                            industryType: change.target.value,
                        })
                    }
                />
                <br />
                <TextareaField
                    label="Key operational goals"
                    placeholder="e.g. Maximize efficiency, Ensure safety, Reduce costs"
                    value={organizationPromptComponents.keyOperationalGoals}
                    onChange={change =>
                        setOrganizationPromptComponents({
                            ...organizationPromptComponents,
                            keyOperationalGoals: change.target.value,
                        })
                    }
                    rows={10}
                />
                <br />
                <TextareaField
                    label="Core values"
                    placeholder="e.g. Sustainability, Cost Efficiency, Safety First"
                    value={organizationPromptComponents.coreValues}
                    onChange={change =>
                        setOrganizationPromptComponents({
                            ...organizationPromptComponents,
                            coreValues: change.target.value,
                        })
                    }
                    rows={10}
                />
                <br />
                <TextareaField
                    label="KPIs"
                    placeholder="e.g. Operational Efficiency, Success Rate"
                    value={
                        organizationPromptComponents.organizationalHealthKPIs
                    }
                    onChange={change =>
                        setOrganizationPromptComponents({
                            ...organizationPromptComponents,
                            organizationalHealthKPIs: change.target.value,
                        })
                    }
                    rows={10}
                />
                <br />
                <TextareaField
                    label="Additional Description"
                    placeholder="e.g. Additional information about the organization"
                    value={organizationPromptComponents.additionalDescription}
                    onChange={change =>
                        setOrganizationPromptComponents({
                            ...organizationPromptComponents,
                            additionalDescription: change.target.value,
                        })
                    }
                    rows={30}
                />
            </div>
        );
    }

    return null;
}
